import apiService from "./ApiService"
import { createQS } from "./Utils"

class LoteService {

  async get(termo, idFiscal, uf, idMunicipio, pagina) {
    try {
      const qs = createQS({ termo, idFiscal, uf, idMunicipio, pagina })
      return await apiService.get('lote?' + qs)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async getById(id) {
    try {
      return await apiService.get('lote/' + id)
    } catch (ex) {
      debugger
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }
  
  async getFiscalByIdLote(idLote) {
    try {
      return await apiService.get('lote/' + idLote + '/fiscal')
    } catch (ex) {
      debugger
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async adicionarFiscal(idLote, idFiscal) {
    try {
      return await apiService.post('lote/' + idLote + '/fiscal', { idFiscal })
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async removerFiscal(idLote, idLoteFiscal) {
    try {
      return await apiService.delete('lote/' + idLote + '/fiscal/' + idLoteFiscal)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async create(data) {
    try {
      return await apiService.post('lote', data)
    } catch (ex) {
      debugger
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }
  
  async update(id, data) {
    try {
      return await apiService.put('lote/' + id, data)
    } catch (ex) {
      debugger
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async delete(id) {
    try {
      return await apiService.delete('lote/' + id)
    } catch (ex) {
      debugger
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }
}

const loteService = new LoteService()
export default loteService